import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Navbar.css';

const Navbar: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated, user, logout } = useAuth();
  const [autoCallMenuOpen, setAutoCallMenuOpen] = React.useState(false);
  const closeTimeoutRef = React.useRef<NodeJS.Timeout | null>(null);

  const isActive = (path: string) => location.pathname === path;
  const isAutoCallActive = () => {
    return isActive('/tts-call') || isActive('/tts-survey') || isActive('/dispatch-call');
  };

  const handleMouseEnter = () => {
    // 닫기 타이머가 있으면 취소
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
      closeTimeoutRef.current = null;
    }
    setAutoCallMenuOpen(true);
  };

  const handleMouseLeave = () => {
    // 0.5초 후에 메뉴 닫기
    closeTimeoutRef.current = setTimeout(() => {
      setAutoCallMenuOpen(false);
    }, 500);
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // 컴포넌트 언마운트 시 타이머 정리
  React.useEffect(() => {
    return () => {
      if (closeTimeoutRef.current) {
        clearTimeout(closeTimeoutRef.current);
      }
    };
  }, []);

  return (
    <nav className="navbar">
      <div className="container">
        <div className="navbar-content">
          <Link to="/" className="navbar-logo">
            <span className="logo-icon">📞</span>
            <span className="logo-text">EasyAutoCall</span>
          </Link>

          <ul className="navbar-menu">
            <li>
              <Link
                to="/"
                className={`navbar-link ${isActive('/') ? 'active' : ''}`}
              >
                홈
              </Link>
            </li>
            <li>
              <Link
                to="/services"
                className={`navbar-link ${isActive('/services') ? 'active' : ''}`}
              >
                서비스 소개
              </Link>
            </li>
            <li>
              <Link
                to="/pricing"
                className={`navbar-link ${isActive('/pricing') ? 'active' : ''}`}
              >
                요금제
              </Link>
            </li>
            <li
              className="navbar-dropdown"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <span className={`navbar-link dropdown-trigger ${isAutoCallActive() ? 'active' : ''}`}>
                오토콜 ▾
              </span>
              {autoCallMenuOpen && (
                <div className="dropdown-menu"
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}>
                  <Link
                    to="/tts-call"
                    className={`dropdown-item ${isActive('/tts-call') ? 'active' : ''}`}
                  >
                    TTS 전화
                  </Link>
                  <Link
                    to="/tts-survey"
                    className={`dropdown-item ${isActive('/tts-survey') ? 'active' : ''}`}
                  >
                    TTS 설문조사
                  </Link>
                  <Link
                    to="/dispatch-call"
                    className={`dropdown-item ${isActive('/dispatch-call') ? 'active' : ''}`}
                  >
                    배차 오토콜
                  </Link>
                </div>
              )}
            </li>
            <li>
              <Link
                to="/sms-send"
                className={`navbar-link ${isActive('/sms-send') ? 'active' : ''}`}
              >
                대량 문자 발송
              </Link>
            </li>
          </ul>

          <div className="navbar-actions">
            {isAuthenticated ? (
              <>
                <div className="user-menu">
                  <Link
                    to="/profile"
                    className={`navbar-link user-link ${isActive('/profile') ? 'active' : ''}`}
                  >
                    {user?.email}
                  </Link>
                  <div className="user-dropdown">
                    <div className="credit-info">
                      <span className="credit-label">보유 크레딧</span>
                      <span className="credit-amount">{user?.creditBalance?.toLocaleString() || 0}원</span>
                    </div>
                    <Link to="/profile" className="dropdown-item">
                      마이페이지
                    </Link>
                    <button onClick={handleLogout} className="dropdown-item logout-btn">
                      로그아웃
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <Link to="/login" className="btn btn-outline btn-sm">
                로그인
              </Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
